var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasuringCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00026 8.61484V9V11H10.0003V12H8.00026V13H10.0003V14H8.00026V15H10.0003V16H8.00026V18H15.0003V15V14V13.9296V9V8V7V6H6.95432L7.85721 8.25722L8.00026 8.61484ZM18.0003 11.9296L17.0003 12.5963V9H18.0003V11.9296ZM4.80026 6L6.00026 9V19C6.00026 19.5523 6.44797 20 7.00026 20H16.0003C16.5525 20 17.0003 19.5523 17.0003 19V15L19.555 13.2969C19.8332 13.1114 20.0003 12.7992 20.0003 12.4648V8C20.0003 7.44772 19.5525 7 19.0003 7H17.0003V5C17.0003 4.44772 16.5525 4 16.0003 4H6.15432H6.15305H5.98877H4.73877C4.38504 4 4.14316 4.35726 4.27454 4.6857L4.73877 5.84629L4.79978 5.99881L4.80026 6Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasuringCup);
export default __webpack_public_path__ + "static/media/measuring_cup.2ca90b054806a61fd2c92e74a9725f97.svg";
export { ForwardRef as ReactComponent };